import { useCallback } from 'react';

import { setAuthData } from '@/features/auth/slices/authSlice';
import { useAppDispatch } from '@/store/hooks';
import { clearWizardDrafts, makeWizardId } from '@web/utils/src/wizardStorage';

import type { User } from '@web/types';

type AuthEntities = {
  currentUser?: User | null;
  currentWorkspaceSlug?: string | null;
  isWorkspaceSetupRequired?: boolean | null;
  isWorkspaceOnboarded?: boolean | null;
};

export function useBootstrapAuth() {
  const dispatch = useAppDispatch();

  return useCallback(
    (entities?: AuthEntities) => {
      const currentUser: Omit<User, 'id'> | null =
        entities?.currentUser != null
          ? (({ id, ...rest }: User) => rest)(entities.currentUser)
          : null;

      dispatch(
        setAuthData({
          currentUser,
          currentWorkspaceSlug: entities?.currentWorkspaceSlug ?? null,
          isWorkspaceSetupRequired: entities?.isWorkspaceSetupRequired ?? null,
          isWorkspaceOnboarded: entities?.isWorkspaceOnboarded ?? null,
        }),
      );

      // * If server indicates workspace is onboarded, clear any wizard drafts.
      const isOnboarded = entities?.isWorkspaceOnboarded ?? null;
      if (isOnboarded === true) {
        try {
          const wizId = makeWizardId(
            entities?.currentUser?.email ?? null,
            entities?.currentWorkspaceSlug ?? null,
          );
          clearWizardDrafts(wizId);
        } catch {
          console.error('Error clearing wizard drafts');
        }
      }
    },
    [dispatch],
  );
}
